import React from 'react'
import { Box, Flex } from 'reflexbox';
import { Paper, Typography, Select } from '@material-ui/core'
import { colors, HealtheraButton } from '../../../healtheraComponents'
import styled from 'styled-components'
import CloseIcon from '@material-ui/icons/Close'
import SearchIcon from '@material-ui/icons/Search'

export const AddProceedCancelDialogButtons = (onProceed, onCancel) => (
  <>
    <HealtheraButton onClick={onProceed} margin={'0 10px 5px'} height={'32px'} width={'95px'} color="primary">
      Proceed
    </HealtheraButton>
    <HealtheraButton onClick={onCancel} margin={'0 10px 5px'} height={'32px'} background={'#d0021b'} width={'95px'} >
      Cancel
    </HealtheraButton>
  </>
);

export const Search = styled.input`
  && {
  height: 43px;
  border-radius: 13px;
  background-color: #ffffff;
  font-size: 16px;
  padding: 0 12px;
  color: #333;
  width: 475px;
  display: inline-block;
  }
  border:0;
  &&:focus {
    outline: none;
  }
`;
export const SearchBox = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  margin: 12px;
  height: 43px;
  border-radius: 13px;
  box-shadow: 0 1px 2px 0 rgba(80,80,80,0.2);
  background-color: #ffffff;
  width: 100%;
`;

export const SearchIconStyled = styled(SearchIcon)`
  width: 25px;
  margin-right: 15px;
  cursor: pointer;
`;
export const CloseIconStyled = styled(CloseIcon)`
  width: 25px;
  margin-right: 15px;
  cursor: pointer;
`;
export const ListContainer = styled(Paper)`
  position: absolute;
  overflow: auto;
  max-height: 300px;
  z-index: 1;
  width: 50%;
`;

export const Card = styled.div`
  padding: 28px 24px;
  box-shadow: 0 0 6px 3px rgba(0, 0, 0, 0.1);
  background-color: white;

  display: flex;
  flex-direction: column;
`;

export const SettingHeader = styled(Box)`
  && {
    color: ${colors.DARK};
    margin-bottom: 16px;
    font-size: 20px;
    font-weight: 700;
  }
`;

export const DetailsLabel = styled(Typography)`
  && {
    color: ${colors.DARK};
    font-size: 17px;
    font-weight: 600;
  }
`;

export const SettingsLabel = styled(DetailsLabel)`
  && {
    margin-top: 1rem;
    margin-bottom: 0.3rem;
  }
`

export const SettingsContainer = styled(Card)`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SettingsSelect = styled(Select).attrs({
  classes: {
    select: 'branch-select'
  }
})`
  &&::after, &&:before {
    border: none;
  }

  && {
    background-color: ${colors.FADED_LIGHT};
  }

  && .branch-select {
    padding: 16px;
  }
`;

export const PayOnCollectionSelect = styled(SettingsSelect)`
  && {
    display: flex;
  }
  && .branch-select {
    padding-right: 26px;
  }
`

export const TitleContainer = styled.span`
  margin: 0;
  margin-right: 5px;
`;

export const SmallButton = styled(HealtheraButton).attrs({
  width: 'auto',
  height: 'auto',
  padding: '0 5px'
})`
  && {
    font-size: 12px;
    min-width: 50px;
  }
`;

export const DateInput = styled.input.attrs({
  type: 'date'
})``;

export const NumberInput = styled.input.attrs({
  type: 'number'
})``;

export const ModalButton = styled(HealtheraButton).attrs({
  width: 'auto',
  height: 'auto',
  padding: '5px 10px'
})`
  && {
    margin-left: 5px;
    height: auto;
  }
`;

export const VerticalFlex = styled(Flex)`
  flex-direction: column;
`;
